import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { Moon, Sparkles, ArrowRight } from "lucide-react";
import { BANK_INFO } from "@/data/services";
import { useSiteContent } from "@/hooks/useSiteContent";

export const Hero = () => {
  const { t } = useLanguage();
  const { get } = useSiteContent();
  const scrollTo = (id) => {
    (document.getElementById(id) || document.getElementById("servicios"))?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            `url('${get("hero.image", "https://images.pexels.com/photos/18911837/pexels-photo-18911837.jpeg")}')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/40 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-2 mb-6 text-[#d4af37]">
            <Moon className="w-4 h-4" />
            <span className="uppercase tracking-[0.3em] text-xs" data-testid="hero-badge">{get("hero.badge", t("hero.eyebrow"))}</span>
          </div>

          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mb-8 text-white whitespace-pre-line" data-testid="hero-title">
            {get("hero.title", t("hero.title")).split("\n").map((line, i) => (
              <span key={i} className="block">
                {i === 0 ? <span className="gold-text italic">{line}</span> : line}
              </span>
            ))}
          </h1>

          <div className="divider-gold max-w-xs mb-8" />

          <p className="text-lg sm:text-xl text-neutral-300 mb-10 max-w-xl leading-relaxed" data-testid="hero-subtitle">
            {get("hero.subtitle", t("hero.subtitle"))}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-services"
              onClick={() => scrollTo("lecturas")}
              className="btn-gold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2 uppercase text-sm tracking-widest"
            >
              {t("hero.ctaPrimary")} <ArrowRight className="w-4 h-4" />
            </button>
            <a
              data-testid="hero-cta-whatsapp"
              href={BANK_INFO.whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="btn-outline-gold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2 uppercase text-sm tracking-widest"
            >
              <Sparkles className="w-4 h-4" /> {t("hero.ctaSecondary")}
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-[#d4af37]/8 blur-3xl pointer-events-none" />
    </section>
  );
};
